/* src/app/feature-modules/schools/school-details/school-details.component.css */
.row {
  margin-bottom: 20px;
  overflow-wrap: break-word;
}
h4 {
  font-weight: 500;
  line-height: 1.36;
  color: #5b6779;
  display: inline-block;
  font-size: 14px;
  margin: 0px;
}
.sub-entry {
  width: 50%;
  float: left;
}
.info-container {
  padding: 20px 29px 0px 30px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 0.5px #babbc7;
  height: 50%;
  overflow: auto;
  margin-bottom: 10px;
}
/*# sourceMappingURL=school-details.component.css.map */
